import { render, staticRenderFns } from "./cero_detail.vue?vue&type=template&id=67f0436d"
import script from "./cero_detail.vue?vue&type=script&lang=js"
export * from "./cero_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports